/* eslint-disable no-console */
import api from '../api';
import * as Types from '../types';

/**
 * Get a remote working post from its ID
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @return {Promise<Types.RemoteWorkingPost>} Response from API under Axios instance
 */
export const getRemoteWorkingPost = async (queryParams) => {
  const result = await api.get(
    `/calendars/${queryParams.year}/remote-working-posts/${queryParams.postId}`,
  );

  try {
    await Types.remoteWorkingPostSchema.validateAsync(result.data);
  } catch (error) {
    console.error(error);
    throw Error(`getRemoteWorkingPost result do not validate remoteWorkingPostSchema : ${error}`);
  }

  return result.data;
};

/**
 * Create a new remote working post
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} data
 * @param {string} data.resourceId
 * @param {number} data.includedStartSlotId
 * @param {number} data.excludedEndSlotId
 * @param {({excludedEndSlotId:number}|null)} data.recurrence
 * @param {string|null} data.address
 * @param {string|null} data.comment
 * @return {Promise} Response from API under Axios instance
 */
export const postRemoteWorkingPost = (queryParams, data) => api.post(
  `/calendars/${queryParams.year}/remote-working-posts`,
  data,
);
